var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAndroid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 9a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m18 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-4.14-5.5a1 1 0 1 0-1.73-1l-.62 1.06a5.93 5.93 0 0 0-5.04 0L8.86 2.5a1 1 0 1 0-1.73 1l.69 1.2A5.98 5.98 0 0 0 5.99 9v8a1 1 0 0 0 1 1h2v3a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 2 0v-3h2a1 1 0 0 0 1-1V9a5.98 5.98 0 0 0-1.83-4.3zM15.99 16H8v-5h8v5ZM8 9a4 4 0 0 1 8 0z"
})));
export default SvgIcAndroid;